















































































































































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import TaskApi from '@/api/task'
import MediateApi from '@/api/mediate'
import AreaApi from '@/api/area'
import { checkCarNo, debounce } from '@/utils/util'
import InvestigateApi from '@/api/investigate'
import addTaskMixin from './addTaskMixin'
import moment from 'moment'
import { beforeAddTask } from '@/utils/order'

let id: any = 0

const debounceSearch = debounce(300)

@Component({
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
	},
})
export default class PureMediate extends Mixins(addTaskMixin) {
	public taskType: any = '9'

	private disabledDate(current: any) {
		return current && current > moment().endOf('day')
	}

	public onTaskAdd(e: any) {
		e.preventDefault()
		this.addForm.validateFields(async (err: any, values: any) => {
			if (!err) {
				// validateFields存在异步校验
				// 避免快速多次的点击创建多个相同任务
				if (this.addLoading) {
					return
				}
				values = cloneDeep(values)
				const codes = values.code.key.split('-')
				values.provinceCode = codes[0]
				values.cityCode = codes[1]
				values.countryCode = codes[2]
				delete values.code
				delete values.injuredPhone

				values.accidentDate = values.accidentDate.format('YYYY-MM-DD')
				values.taskType = this.taskType

				this.addLoading = true
				MediateApi.addTask(values)
					.then((data: any) => {
						this.$message.success(data.message || '发布成功')
						this.resetPage()
						this.$multiTab.closeCurrentPage()
						this.$multiTab.open('/AiiTasks/TasksList')
					})
					.finally(() => {
						this.addLoading = false
					})
			} else {
				if (err.caseNo) {
					this.caseWaring = 'error'
					this.caseHelpMes = err.caseNo.errors[0].message
				}
			}
		})
	}
}
